const getOptimizelyConfig = () => ({
  // Logging options are 'notset', 'debug', 'info', 'warn' (='warning'), 'warning', and 'error'.
  // Default log level is 'error'.
  // https://docs.developers.optimizely.com/full-stack/docs/customize-logger-javascript-node
  logLevel: process.env.optimizelyLogLevel || 'warn',
  // SDK config options
  sdkKey: process.env.optimizelySdkKey || 'S6r9HQkFJ7h7DT5T9yxVD',
  dataFilePath: process.env.optimizelyDatafileUrl,
  instanceRefreshInterval: Number(process.env.optimizelyDatafileRefreshMS) || 15 * 60000,
  // default 15m
  eventBatchSize: 10,
  // These are defaults in the Optimizely sdk, but they still warn you if not explicitly passed in
  eventFlushInterval: process.env.optimizelyEventFlushInterval || (typeof window !== 'undefined' ? 1000 : 30000),
  // These are defaults in the Optimizely sdk, but they still warn you if not explicitly passed in

  // Cookie options
  expCookieName: 'optlyExps',
  featCookieName: 'optlyFeats',
  revisionCookieName: 'optlyRev',
  cookieOptions: {
    // 2 years in seconds
    maxAge: 63072000,
    path: '/'
  },
  // Url param options
  delimiter: '!',
  featureVariableDelimiter: '|',
  variableDelimiter: '~',
  variableValueDelimiterRegex: /:(.+)/,
  // skip json ':', first occurrence of :
  forceExpParam: 'optimizelyForceExperiments',
  forceFeatureParam: 'optimizelyForceFeatures',
  // Config options for waitUntil method being used in ./decisionListener.js
  retryMS: 50
});
export default getOptimizelyConfig;